// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"WorkshpoCardsSection_cardContainer__MUJob","cardBox":"WorkshpoCardsSection_cardBox__NNHra"};